import type { FaireProductEntity } from "../../entity_types/product";

export const toysmith_10: FaireProductEntity = {
  token: "toysmith-10",
  type: "product",
  name: "Toysmith Large Dump Truck",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/656347750ea11d41442964214a0a68fb723620269c24ab351b5db633a8915c33.jpeg?bg-color=FFFFFF&canvas=720:720&dpr=1&fit=bounds&format=jpg&height=720&width=720",
  priceDollars: 13,
  msrpDollars: 26,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-toys"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
